<template>
<div class="btnBox fullBtn">
    <a href="https://play.google.com/store/apps/details?id=kr.co.bmwkorea.plus" class="btnL">
        <img class="pmIconPosition" src="https://icongr.am/devicon/google-original.svg?size=30&color="> Google Play 다운로드
    </a>
    <a href="https://apps.apple.com/kr/app/bmw-plus/id1281874994" class="btnL">
        <img class="pmIconPosition" src="https://icongr.am/devicon/apple-original.svg?size=30&color="> App Store 다운로드
    </a>
    <!-- <a href="https://play.google.com/store/apps/details?id=kr.co.bmwkorea.plus" class="btnL">Google Play 다운로드</a>
    <a href="https://apps.apple.com/kr/app/bmw-plus/id1281874994" class="btnL">App Store 다운로드</a> -->
</div>
</template>

<script>
export default {
    props: {},
}
</script>



<style lang="css" scoped>
.pmIconPosition{
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 5px;
}
</style>



